export const config = {
  fieldControl: false,
  tableType: 'antd',
  columns: [
    { title: '序号', dataIndex: 'sort', width: 120, render: 'sortRender' },
    { title: '费用名称', dataIndex: 'name', width: 200, render: 'nameRender', ellipsis: true },
    { title: '适用产品', dataIndex: 'productName', width: 200, ellipsis: true },
    { title: '适用门店', dataIndex: 'orgName', width: 200, ellipsis: true },
    { title: '报价面积 (平米)', dataIndex: 'budgetArea', width: 200, ellipsis: true },
    { title: '卫生间个数', dataIndex: 'toiletNum', width: 200, ellipsis: true },
    { title: '金额 (元)', dataIndex: 'price', width: 200, ellipsis: true },
    { title: '开始日期', dataIndex: 'startDate', width: 180, itemType: 'date' },
    { title: '结束日期', dataIndex: 'endDate', width: 180, itemType: 'date' },
    { title: '操作', dataIndex: '#', width: 140, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    { name: 'prodCateId', hidden: true },
    {
      label: '适用产品',
      name: 'productId',
      itemType: 'custom',
      render: 'searchSelectRender',
    },
    {
      label: '适用门店',
      name: 'orgId',
      itemType: 'select',
      labelKey: 'name',
      key: 'id',
      data: 'companyList',
    },
    {
      label: '面积范围',
      name: '',
      itemType: 'custom',
      render: 'areaRangeRender',
    },
    {
      label: '',
      name: 'budgetAreaStart',
      hidden: true,
    },
    {
      label: '',
      name: 'budgetAreaEnd',
      hidden: true,
    },
  ],
  footer: [
    { label: '导出', render: 'exportRender' },
    { label: '导入', render: 'importRender' },
  ],
  batchActions: [
    {
      label: '开始日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateStart'],
    },
    {
      label: '结束日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateEnd'],
    },
    {
      label: '删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchDel'],
    },
  ],
}
